import React from "react";

const SignInCTA = ({ hideCTA = false }) => {
  // const hide =
  //   typeof hideCTA === "boolean"
  //     ? hideCTA
  //     : hideCTA === "true"
  //     ? true
  //     : false;
  // will not check whether user has logged in, if logged in already, signIn link will take them through verify password page
  const hide = false;

  return (
    <>
      {!hide && (
        <div className="iam-cta-container button-style hidden-xs-only">
          <p>Already have an account?</p>
          <a
            role="button"
            href={`${window.appConfig.baseUrlWithProxy}/login/login`}
            className="cb-btn cb-btn-black cb-margin-top-8 cb-width-100"
          >
            Sign In
          </a>
        </div>
      )}
    </>
  );
};

export default SignInCTA;
